import React from 'react'
import CarouselIndex from '../../components/Carousel'
import Title from '../../components/Title'
import '../../css/Service.scss'
import { Helmet } from 'react-helmet';


const Carousel_text = [
  {
    carouselImage: 'https://static.yiliit.com/qolai_cn/service_banner.png',
    text: [
      { text: '趣来达', colorText: '' },
      { text: '，全方位满足各阶段用户所需', colorText: '标准化服务体系' }
    ],
    iconscenes:[
      {icon:'https://static.yiliit.com/qolai_cn/service/ic_banner1.png',text:'SAAS租用', width:'138px'},
      {icon:'https://static.yiliit.com/qolai_cn/service/ic_banner2.png',text:'OEM品牌', width:'138px'},
      {icon:'https://static.yiliit.com/qolai_cn/service/ic_banner3.png',text:'特殊功能定制', width:'138px'},
      {icon:'https://static.yiliit.com/qolai_cn/service/ic_banner4.png',text:'独立部署', width:'138px'}
    ]
  }
]

const moduleArr = [
  {
    icon: 'icon-service-modulesA1',
    title: 'SAAS租用',
    text: '基础版全套系统使用，搭建客户独立品牌的平台小程序，提供免费的技术维护服务、系统更新服务，以及专人售后服务'
  },
  {
    icon: 'icon-service-modulesA2',
    title: 'OEM品牌定制',
    text: '支持骑士和商家APP（Android+IOS）应用定制、团队后台、商家后台客户端定制，域名定制，短信定制，打造全套品牌化平台，享受升级单独更新'
  },
  {
    icon: 'icon-service-modulesA4',
    title: '独立部署',
    text: '支持单个用户平台服务独立部署，独立服务器，专人运维，保障信息数据独立且安全，需要随时导出'
  },
  {
    icon: 'icon-service-modulesA3',
    title: '特殊功能定制',
    text: '针对个别用户某些特殊功能需求，支持多对一定制服务，匹配产品人员、UI设计、前后端开发、测试全产品线小组服务'
  },
]
const scopeArr = [
  {
    img: 'https://static.yiliit.com/qolai_cn/service/service_scene2_image1.png',
    title: 'SaaS租用模式',
    title2: '轻投入·快启动·省心运营',
    text_arr: [
      '1、投入成本低，降低创业门槛', 
      '2、快速搭建，缩短上线周期', 
      '3、省去云服务及技术运维成本', 
      '4、系统持续更新，享受产品迭代', 
      '5、专心技术支持，降低管理压力', 
      '6、业务配置灵活，适应不同运营场景', 
      '7、试错成本可控，便于验证商业模式'
    ]
  },
  {
    img: 'https://static.yiliit.com/qolai_cn/service/service_scene2_image2.png',
    title: 'OEM品牌定制模式',
    title2: '专属品牌·自主形象·成熟技术支撑',
    text_arr: [
      '1、专属品牌形象，打造自由平台',
      '2、自定义品牌域名，强化品牌独立性',
      '3、无需从零研发，缩短品牌平台建设周期',
      '4、自主品牌推广，积累长期品牌资产',
      '5、提升品牌合作形象，增强本地信任体系',
      '6、保留成熟业务能力，降低产品建设难度',
      '7、支持品牌长期经营，便于市场拓展'
    ]
  },
  {
    img: 'https://static.yiliit.com/qolai_cn/service/service_scene2_image3.png',
    title: '独立部署模式',
    title2: '独立运行·数据自主·灵活扩展',
    text_arr: [
      '1、专属服务器部署，运行环境独立',
      '2、数据库独立，业务数据自主掌握',
      '3、数据环境隔离，配备独立技术运维',
      '4、更便于定制开发，特色业务需求更易满足',
      '5、支持自主安全数据备份与迁移',
      '6、独立规划系统升级，减少统一变更影响',
      '7、适合长期业务建设，支撑企业持续发展'
    ]
  }
]
const flowArr = [
  {
    icon: 'bg-service-modulesD1',
    title: '沟通需求',
  },
  {
    icon: 'bg-service-modulesD2',
    title: '评估开发周期与人员配置',
  },
  {
    icon: 'bg-service-modulesD3',
    title: '签约打款',
  },
  {
    icon: 'bg-service-modulesD4',
    title: '设计功能产品原型',
  },
  {
    icon: 'bg-service-modulesD5',
    title: 'UI设计出图',
  },
  {
    icon: 'bg-service-modulesD6',
    title: '技术人员开发',
  },
  {
    icon: 'bg-service-modulesD7',
    title: '功能测试',
  },
  {
    icon: 'bg-service-modulesD8',
    title: '上线交付',
  },
]

let pageTimer = '' //停留时间

class DispatchSystem extends React.Component {
  state = {

  };

  componentWillMount() {
    let id = '#' + this.getQueryVariable('id')
    if(id !== "#undefined"){
      window.location.href = id
    }
    // 获取进入页面的时间
		if (pageTimer === '') {
			pageTimer = parseInt(new Date().getTime() / 1000);
			console.log(pageTimer,'pageTimer')
		}
    this.props.onVisitClick({
      type: 1,
      domain: 'www.qolai.cn',
      page: 'service'
    },0)
  }

  componentWillUnmount() {
    // 离开时间减去进入时间
    const tempTimer = parseInt(new Date().getTime() / 1000) - pageTimer;
    console.log(tempTimer,'tempTimer')
    // 清空时间戳
    pageTimer = '';
    if (tempTimer > 0) {
      this.props.onVisitClick({
        type: 2,
        domain: 'www.qolai.cn',
        page: 'service',
        time: tempTimer
      },0)
    }
  }

  getQueryVariable(variable){
    var query = window.location.search.substring(1);
    if(window.location.hash){
      return;
    }
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] === variable){return pair[1];}
    }
    return(false);
  } 

  shouldComponentUpdate(newValue,Oldvalue){
    let id = '#' + this.getQueryVariable('id')
    if(id !== "#undefined"){
      window.location.href = id
    }
  }


  render() {
    return (
      <div>
        <Helmet>
          <title>趣来达提供SaaS-OEM品牌定制-独立部署</title>
          <meta name="Description" content="趣来达旗下跑腿系统、外卖系统，同城生活系统，校园外卖配送系统，提供SaaS租用、OEM品牌定制、特殊功能定制、和独立部署服务。" />
          <meta name="Keywords" content="SaaS,OEM品牌定制,独立部署" />
        </Helmet>
        {/**顶部banner**/}
        <CarouselIndex data={Carousel_text} />

        {/* 为什么选择趣来达外卖系统 */}
        <div style={{ marginTop: '80px' }} id="1">
          <Title title="多元化服务类型全面满足用户"
            text="Diversified services"
            dec="针对前期创业、中期进阶、后期拓展所有阶段都提供有不同的价格、品牌化的针对性服务，让你拥有匹配你发展阶段的服务，拥有独立、自主、品牌发展空间更大"
            width={710}
            height={66} />
          <div className="d-flex justify-content-center">
            <div className="detaile-module5-box" style={{ width: '1440px', height: '296px', flexWrap: 'wrap' }}>
              {moduleArr.map(item => {
                return (
                  <div className="detaile-module5-box-item" style={{ width: '338px', height: '296px' }}>
                    <img alt=""
                      style={{
                        width: '80px',
                        height: '80px',
                      }}
                      src={require(`../../asset/service/${item.icon}.png`)} />
                    <div
                      style={{
                        fontSize: '24px',
                        color: '#333333',
                        marginBottom: '19px',
                        fontWeight: 'bold'
                      }}
                    >
                      {item.title}
                    </div>
                    <div
                      style={{
                        fontSize: '14px',
                        color: '#707070',
                        fontWeight: '600',
                        textAlign: 'center'
                      }}
                    >
                      {item.text}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        {/**趣来达跑腿配送系统 - 价值亮点**/}
        <div>
          <Title title="不同合作模式，有何优势？"
            text="What advantages"
            width={710}
            height={66} />
          <div className="d-flex justify-content-center">
            <div className="d-flex flex_column align-items-center" style={{ width: '1440px', maxWidth: '100%', padding: '0 20px', boxSizing: 'border-box' }}>
              <div className="service-advantages" style={{ width: '101%' }}>
                {scopeArr.map((item) => (
                  <div className="service-advantages-column" key={item.title}>
                    <div className="service-advantages-header">
                      <div className="service-advantages-image" style={{ backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, .75), rgba(0, 0, 0, .12)), url(${item.img})` }} />
                      <div className="service-advantages-title">{item.title}</div>
                      <div className="service-advantages-subtitle">{item.title2}</div>
                    </div>
                    <div className="service-advantages-list">
                      {item.text_arr.map((text) => (
                        <div className="service-advantages-item" key={text}>{text}</div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div style={{ width: '100%', overflow: 'hidden' }}>
          <div style={{ position: 'relative', width: '1920px', left: '50%', transform: 'translateX(-50%)' }}>
            <img alt="" src="https://static.yiliit.com/qolai_cn/service/service_scene3.png" style={{ display: 'block', width: '1920px', height: 'auto' }} />
            <div style={{ position: 'absolute', top: '93px', left: 0, width: '100%', zIndex: 1 }}>
              <Title title="独立平台品牌化定制"
                text="branded customization"
                width={710}
                height={66}
              />
            </div>
          </div>
        </div>
        {/* 为什么选择趣来达外卖系统 */}
        <div style={{ marginTop: '80px' }} id="4">
          <Title title="特殊功能定制服务流程？"
            text="service process"
            width={710}
            height={66} />
          <div className="d-flex jscen" style={{ marginBottom: '100px' }}>
            {
              flowArr.map((item, index) => {
                return (
                  <div className='service-flow-box' style={{ color: (index + 1) % 2 === 1 ? '#333333' : '', background: (index + 1) % 2 === 1 ? '' : '#333333' }}>
                    <img alt=""
                      style={{
                        width: '40px',
                        height: '40px',
                        marginBottom: '16px'
                      }}
                      src={require(`../../asset/service/${item.icon}.png`)} />
                    <p>
                      {item.title}
                    </p>
                    <img alt="" className={index === 7 ? 'display-none service-flow-arrows' : 'service-flow-arrows'} src={require(`../../asset/service/${(index + 1) % 2 === 1 ? 'yellow-triangle' : 'black-triangle'}.png`)} />
                  </div>
                )
              })

            }
          </div>
        </div>
      </div>
    )
  }
}

export default DispatchSystem;